











import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import DefinitionForm from "./Components/DefinitionForm.vue";
import Definition from "@/models/definition";
import DefinitionsAPI from "@/services/definitions";

@Component({
  components: { DefinitionForm },
})
export default class EditDefinition extends Vue {
  model: Definition | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getRecord();
  }

  async getRecord(): Promise<void> {
    try {
      const r = await DefinitionsAPI.get(this.$route.params.id);
      this.model = r;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  async save(model: Definition): Promise<void> {
    LayoutModule.showLoader();
    try {
      await DefinitionsAPI.update(model);
      LayoutModule.setAlerts({
        text: this.$t("definitions.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "definitions" });
  }
}
